import { createFileRoute } from "@tanstack/react-router";
import { ArticlePage } from "@/components/ArticlePage";
import { articleSchemas, qaSchema } from "@/lib/seo";

const UPDATED = "2026-10-14";
const ANSWER = "Shopify ist stark, wenn Sie schnell verkaufen wollen, ohne sich um Server, Sicherheit und Updates zu kümmern. Grenzen zeigen sich bei sehr speziellen Abläufen, bei laufenden App-Kosten und bei manchen deutschen Rechtsanforderungen, die eigene Einrichtung brauchen.";
const SITE = "https://shopify-freelancer.net";
const PATH = "/fragen/shopify-erfahrungen";
const TITLE = "Shopify Erfahrungen: Vorteile und Nachteile";
const DESCRIPTION = "Shopify Erfahrungen aus der Praxis eines Freelancers: wo Shopify stark ist, wo es Grenzen hat und für wen es sich lohnt.";

const faqs = [
  { q: "Ist Shopify für kleine Shops geeignet?", a: "Ja. Gerade kleine Shops profitieren davon, dass Technik und Sicherheit nicht selbst gepflegt werden müssen." },
  { q: "Ist Shopify in Deutschland rechtssicher?", a: "Shopify selbst liefert die Technik. Rechtstexte, Cookie-Einwilligung und Pflichtangaben müssen Sie einrichten, am besten mit einem Rechtstexte-Anbieter." },
  { q: "Kann ich später wechseln?", a: "Ja, Produkte und Kunden lassen sich exportieren. Ein Wechsel ist aber immer Aufwand, deshalb lohnt die richtige Wahl am Anfang." },
];

export const Route = createFileRoute("/fragen/shopify-erfahrungen")({
  component: Page,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      ...articleSchemas({ title: TITLE, description: DESCRIPTION, path: PATH, faqs, section: "Shopify Erfahrungen", updated: UPDATED, breadcrumb: { name: "Fragen", path: "/fragen" } }),
      qaSchema({ question: TITLE, answer: ANSWER, path: PATH, updated: UPDATED }),
    ],
  }),
});

function Page() {
  return (
    <ArticlePage
      kicker="Frage · Erfahrungen"
      title={TITLE}
      intro="Aus meiner Arbeit mit Shopify-Shops: Für die meisten Händler ist Shopify eine gute Wahl, wenn man die Schwächen kennt und von Anfang an einplant."
      source="frage-shopify-erfahrungen"
      answer={ANSWER}
      updated={UPDATED}
      breadcrumb={{ to: "/fragen", label: "Fragen" }}
      sections={[
        { h: "Vorteile", p: [], list: ["Kein Server, keine Sicherheitsupdates, keine Ausfälle durch Plugins", "Schneller Start und einfache Bedienung im Alltag", "Große Auswahl an Themes und Apps", "Wächst mit, bis hin zu Shopify Plus"] },
        { h: "Nachteile", p: [], list: ["Laufende Kosten für Tarif und Apps", "Weniger Freiheit bei sehr speziellen Abläufen", "Rechtstexte, Steuern und Zahlungsarten für Deutschland brauchen saubere Einrichtung"] },
        { h: "Für wen sich Shopify lohnt", p: ["Für Händler, die sich aufs Verkaufen konzentrieren wollen statt auf Technik. Wer sehr individuelle Prozesse hat, sollte vorher prüfen lassen, ob Shopify sie abbilden kann."] },
      ]}
      faqs={faqs}
      related={[{ to: "/fragen/shopify-oder-woocommerce", label: "Shopify oder WooCommerce?" }, { to: "/fragen/shopify-vs-shopware", label: "Shopify oder Shopware?" }, { to: "/shopify-freelancer", label: "Shopify Freelancer" }]}
    />
  );
}
